<template>
    <div class="flex flex-col">
        <div :key="item" v-for="(item, index) in steps"
             class="relative mb-6  items-center before:absolute before:left-2.5 before:top-0 before:mt-6 before:h-full before:w-1 before:bg-grey-20 before:content-['_'] after:absolute
            after:left-2.5 after:top-0 after:mt-6 after:w-1 after:!bg-eureka-500 last:before:content-none last:after:content-none"
             :class="{
                 'after:h-full': index + 1 < currentStep
             }">
            <div class="flex h-6 items-center">
                <div class="absolute flex h-6 w-6 shrink-0 items-center justify-center rounded-full" :class="index + 1 <= currentStep ? ['bg-eureka-500', 'text-white'] : ['bg-grey-20', 'text-grey-90']">{{ index+1 }}</div>
                <div class="pl-8 font-semibold">
                    <slot name="title">{{ item }}</slot>
                </div>
            </div>

            <div v-if="slots[index + 1]" class="mt-2 pl-8 pr-2.5">
                <slot :name="index + 1" :item="item" :step="index + 1"></slot>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { useSlots } from 'vue';

interface IProps {
    steps: string[];
    currentStep: number;
}

withDefaults(defineProps<IProps>(), {
    steps: () => [],
    currentStep: 1,
});

const slots = useSlots();
</script>
